import React, { useState } from "react";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../store";
import * as CreditActions from "../store/credit/actions";
import { isIDFPartnerUser } from "../util/partner";
import { DialogComponent } from "./common/DialogComponent";
import LanguagePreferenceDialog from "./Dialogs/LanguagePreferenceDialog";
import { useTranslation } from "react-i18next";
import * as LoginActions from "../store/loginService/actions";
import { useLocation } from "react-router-dom";
import yourPrivacyChoice from "../Assets/images/yourPrivacyChoice.svg";
import TwitterXIcon from "../Assets/images/icon-x-color.svg";
import LegalDocumentContainer from "./LegalDocumentPages/LegalDocumentContainer";

const PageFooter = () => {
    const dispatch = useDispatch();
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const requestCreditAuth = () => dispatch(CreditActions.actionCreators.requestValidateAuthentication());
    const legalDocUpdate = useSelector((state: ApplicationState) => {
        if (state.configurationState && state.configurationState.configuration && state.configurationState.configuration.partnerConfig) {
            return {
                termsAndConditionUpdated: state.configurationState.configuration.partnerConfig.termsAndCondtionsUpdated,
                privacyPolicyUpdated: state.configurationState.configuration.partnerConfig.privacyPolicyUpdated,
            };
        }
        return { termsAndConditionUpdated: false, privacyPolicyUpdated: false };
    });

    let authData = useSelector((state: ApplicationState) => {
        if (state.creditAuthData.authData != null) {
            let authStatus = state.creditAuthData.authData["auth-status"];
            return {
                isIDFUser: state.creditAuthData.authData.isIDFUser,
                authenticated: authStatus ? authStatus.toUpperCase() : "NONE",
                message: state.creditAuthData.authData.message,
            };
        }
        return { isIDFUser: "", authenticated: "", message: "" };
    });
    const { personalInformationLabel, personalInformationLink } = LegalDocumentContainer();
    const isWhiteLabeled = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isWhiteLabeled
            ? state.configurationState.configuration.partnerConfig.isWhiteLabeled
            : false
    );

    const partnerLegalName = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.legalName
            ? state.configurationState.configuration.partnerConfig.legalName
            : "Sontiq"
    );

    const isFrenchOnlyPartner: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isFrenchOnlyPartner
            ? state.configurationState.configuration.partnerConfig.isFrenchOnlyPartner
            : false
    );

    const isShowSocialMediaLinks = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isShowSocialMediaLinks
            ? state.configurationState.configuration.partnerConfig.isShowSocialMediaLinks
            : false
    );


    const ensureDataFetched = () => {
        if (authData.authenticated === "AUTHENTICATED") {
            requestCreditAuth();
        }
    };

    const doNotSellMyInformationLegalDocumentLink: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.doNotSellMyInformationLegalDocumentLink
            ? state.configurationState.configuration.partnerConfig.doNotSellMyInformationLegalDocumentLink
            : ""
    );
    const termsOfUseLegalDocumentLink: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLink
            ? state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLink
            : ""
    );
    const privacyPolicyLegalDocumentLink: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLink
            ? state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLink
            : ""
    );
    //const commonDefinitionLegalDocumentLink: string = useSelector((state: ApplicationState) => state.configurationState && state.configurationState.configuration.partnerConfig.commonDefinitionLegalDocumentLink ? state.configurationState.configuration.partnerConfig.commonDefinitionLegalDocumentLink : "");
    const termsOfUseLegalDocumentLabel: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLabel
            ? state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLabel === "Terms of Use"
                ? tLang("pageFooter.termsOfUse")
                : state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLabel
            : tLang("pageFooter.termsOfUse")
    );
    const privacyPolicyLegalDocumentLabel: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLabel
            ? state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLabel === "Privacy Notice"
                ? tLang("pageFooter.privacyNotice")
                : state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLabel
            : tLang("pageFooter.privacyPolicy")
    );
    const trustCenterLegalDocumentLink: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.trustCenterLegalDocumentLink
            ? state.configurationState.configuration.partnerConfig.trustCenterLegalDocumentLink
            : ""
    );
    const isIDFPartner = useSelector((state: ApplicationState) =>
        state.configurationState &&
            state.configurationState.configuration.partnerConfig.partnerId &&
            state.configurationState.configuration.partnerConfig.isIdfPartner
            ? !isIDFPartnerUser(state.configurationState.configuration.partnerConfig.partnerId)
            : false
    );
    const isEZSPartner = useSelector((state: ApplicationState) =>
        state.configurationState &&
            state.configurationState.configuration.partnerConfig.partnerId &&
            state.configurationState.configuration.partnerConfig.partnerProvider &&
            state.configurationState.configuration.partnerConfig.partnerProvider === "EZS"
            ? true
            : false
    );
    const [isLanguagePreferenceDialogOpen, setLanguagePreferenceDialogOpen] = useState(false);
    const [isTUVIP, setIsTUVIP] = useState(false);
    const SetPreferencedLanguage = (leng: any, updateUsersLang: boolean) => dispatch(LoginActions.actionCreators.SetPreferencedLanguage(leng, updateUsersLang));
    const preferencedLanguage = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userInfo?.preferencedLanguage
            ? state.loggedInUser.userInfo?.preferencedLanguage
            : null
    );

    const isDynamicFooterAvailable: boolean = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isDynamicFooterAvailable
            ? state.configurationState.configuration.partnerConfig.isDynamicFooterAvailable
            : state.configurationState.configuration.partnerConfig.isIdfPartner && state.configurationState.configuration.partnerConfig.legalName === "IdentityForce" ?
                true : false
    );

    let latestUserDashboardStatus = useSelector((state: ApplicationState) =>
        state.dashboardServiceState && state.dashboardServiceState.userDashboardstatus ? state.dashboardServiceState.userDashboardstatus : ""
    );

    const openDoNotSellMyInformationPage = () => {
        const base_url = decodeURIComponent(encodeURIComponent(window.location.origin)) + "/app";
        if (isFrenchOnlyPartner && i18nLang.resolvedLanguage === "fr") {
            return "https://www.sontiq.com/fr/opt-out-request-form";
        }
        if (isEZSPartner) {
            return "https://www.sontiq.com/opt-out-request-form/";
        }
        if (isIDFPartner) {
            return "https://www.sontiq.com/opt-out-request-form/";
        }
        if (doNotSellMyInformationLegalDocumentLink) {
            const urlToOpen = doNotSellMyInformationLegalDocumentLink.startsWith("/")
                ? base_url + doNotSellMyInformationLegalDocumentLink
                : doNotSellMyInformationLegalDocumentLink;
            return urlToOpen;
        }
        return base_url + "/ccpa";
    };

    const openTrustCenterPage = () => {
        if (isFrenchOnlyPartner && i18nLang.resolvedLanguage === "fr") {
            return "https://www.sontiq.com/fr/help-center";
        }
        return 'https://www.sontiq.com/trust-center';
    };

    const openTermsOfUsePage = () => {
        const base_url = decodeURIComponent(encodeURIComponent(window.location.origin)) + "/app";
        if (isIDFPartner) {
            const urlToOpen = "https://www.sontiq.com/terms-of-use/";
            return urlToOpen;
        }

        if (termsOfUseLegalDocumentLink) {
            const urlToOpen = termsOfUseLegalDocumentLink.startsWith("/") ? base_url + termsOfUseLegalDocumentLink : termsOfUseLegalDocumentLink;
            return urlToOpen;
        }
        return base_url + "/terms";
    };

    const openPrivacyPolicyPage = () => {
        const base_url = decodeURIComponent(encodeURIComponent(window.location.origin)) + "/app";
        if (isIDFPartner) {
            const urlToOpen = "https://www.sontiq.com/privacy-policy/";
            return urlToOpen;
        }

        if (privacyPolicyLegalDocumentLink) {
            const urlToOpen = privacyPolicyLegalDocumentLink.startsWith("/") ? base_url + privacyPolicyLegalDocumentLink : privacyPolicyLegalDocumentLink;
            return urlToOpen;
        }

        return base_url + "/privacy";
    };

    //const openCommonDefinitionPage = (event: any) => {
    //    event.preventDefault();
    //    window.addToDataLayer({ event: 'Common Definition' })

    //    const base_url = window.location.origin + '/app';

    //    if (commonDefinitionLegalDocumentLink) {
    //        const urlToOpen = commonDefinitionLegalDocumentLink.startsWith('/') ? base_url + commonDefinitionLegalDocumentLink : commonDefinitionLegalDocumentLink;
    //        window.open(urlToOpen, '_blank');
    //        return;
    //    }

    //    window.open(base_url + '/common-definition', '_blank');
    //}
    const personalInfoWeCollect = () => {
        if (pathLocation === "ProvisionalResponseLandingPage1" || pathLocation === "ProvisionalResponseLandingPage2" || pathLocation === "StartProtection" || pathLocation === "PssSisk" || pathLocation === "Aflac" || pathLocation === "AflacRegister") {
            return (
                <li>
                    <a
                        href={isFrenchOnlyPartner ? "https://www.sontiq.com/fr/privacy-policy" : "https://www.sontiq.com/privacy-policy/#notice-at-collection"}
                        target="_blank"
                        rel="noreferrer"
                        onClick={() => {
                            window.addToDataLayer({ event: "Personal Information We Collect" });
                        }}
                    >
                        <span className="nav-text">
                            {isIDFPartner ? tLang("PageFooter.label8") : tLang("PageFooter.label8")}
                        </span>
                    </a>
                </li>
            )
        }
        else if (isDynamicFooterAvailable) {
            return (
                <li>
                    <a href={personalInformationLink} target="_blank">
                        <span className="nav-text">{personalInformationLabel}</span>
                    </a>
                </li>
            );
        }
    };
    const newTag = () => {
        return (
            <>
                <span className="new-label">New</span>
            </>
        );
    };

    const isPartnerIdIsNexshield = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 540
                ? true
                : false
            : false
    );
    const isPartnerIdIsGoezshield = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 36
                ? true
                : false
            : false
    );
    const isPartnerIdIsMWB = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2664
                ? true
                : false
            : false
    );
    const isPartnerIdIsEsetGlobal = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2671
                ? true
                : false
            : false
    );
    const isPartnerIdIsInfodefender = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 544
                ? true
                : false
            : false
    );
    const isPartnerIdMyDish = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 484
                ? true
                : false
            : false
    );
    const isPartnerIdADT = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2610
                ? true
                : false
            : false
    );
    const isPartnerIdSentryshield = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 45
                ? true
                : false
            : false
    );

    const isOneTrustPartner = useSelector((state: ApplicationState) => {
        const partnerId = state.configurationState?.configuration?.partnerConfig?.partnerId;
        return partnerId != null && [2649, 1557].includes(partnerId);
    });

    const query = new URLSearchParams(useLocation().search);
    const retailerCode: any = query.get('RetailerCode') || query.get('RETAILERCODE');
    const retailer: any = query.get('retailer') || query.get('Retailer');

    useEffect(ensureDataFetched, []);

    useEffect(() => {
        let checkTUVIP: boolean = (retailerCode != null && retailerCode.toLowerCase() == 'tuvip') || (retailer != null && retailer.toLowerCase() == 'tuvip') ? true : false;
        setIsTUVIP(checkTUVIP);
    }, []);


    useEffect(ensureDataFetched, []);

    const closeLanguagePreferenceDialog = () => {
        setLanguagePreferenceDialogOpen(false);
    };

    useEffect(() => {
        if (!preferencedLanguage) return;
        languageChange(preferencedLanguage, false);
    }, [preferencedLanguage]);

    const languageChange = (languageSelected: string, updateUsersPreferedLang: boolean) => {
        i18nLang.changeLanguage(languageSelected);
        SetPreferencedLanguage(languageSelected, updateUsersPreferedLang);
    };

    //Remove Do not sell text in PSS Landing Pages
    const partnerDisplayName: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerDisplayName
            ? state.configurationState.configuration.partnerConfig.partnerDisplayName
            : ""
    );

    let currentPathLoc = useLocation();
    var currentPath = currentPathLoc.pathname.slice(13);
    const [pathLocation, setPathLocation] = useState("");
    const queryParam = new URLSearchParams(window.location.search);
    const d2cFunnel = currentPathLoc.pathname.includes("sales_landing");
    useEffect(() => {
        currentPath = currentPath.replace("/", " | ");
        currentPath = currentPath.split("-").join(" ");
        currentPath = currentPath.replace(/(?:^|\s)\S/g, (res) => {
            return res.toUpperCase();
        });
        if (currentPath.toLowerCase().includes("pss_landing") === true) {
            document.body.style.paddingTop = "0";
        }
        setPathLocation(currentPath);
    }, [partnerDisplayName, currentPathLoc]);
    return (
        <React.Fragment>
            <footer style={window.location.pathname === '/app/pss_landing/GenericResponseLandingPage'
                || window.location.pathname === '/app/PartnerHomeLogin/TMPL9'
                || window.location.pathname === '/app/pss_landing/PssSisk'
                || window.location.pathname === '/app/pss_landing/Aflac'
                || window.location.pathname === '/app/pss_landing/AflacRegister'
                || (window.location.pathname === '/app/pss_landing/ProvisionalResponseLandingPage2' && queryParam.has('RetailerCode'))
                || (window.location.pathname === '/app/pss_landing/ProvisionalResponseLandingPage1' && queryParam.has('RetailerCode')) ? { position: 'relative' } : {}}>
                {(!d2cFunnel) &&
                    <div className="footer-top">
                        <div className="l-page-container">
                            <div className={`row ${!isPartnerIdADT ? "row-width" : ""} between-sm middle-sm`}>
                                {isPartnerIdADT && (
                                    <div className="copyright-footer">
                                        <span className="copyright-container">
                                            ©&nbsp;<span id="copyright-year">2022</span>
                                            <span id="copyright-text" className="copyright-text">
                                                &nbsp;ADT LLC dba ADT Security Services. All rights reserved. ADT, the ADT logo, ADT Always There and 800.ADT.ASAP and
                                                the product/service names listed in this document are marks and/or registered marks. Third party marks are the property
                                                of their respective owners.
                                            </span>
                                        </span>
                                        <span className="truste-logo">
                                            <div>
                                                <a
                                                    className="compliance-link"
                                                    href="//privacy.truste.com/privacy-seal/validation?rid=43511e02-5eda-4726-b218-13daec452d49"
                                                    title="TRUSTe"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    role="option"
                                                >
                                                    <img className="lazy" alt="TRUSTe" src="https://cdn.ezshield.net/images/_Shared/_Logos/TrustTe_logo.svg" />
                                                </a>
                                            </div>
                                        </span>
                                    </div>
                                )}

                                {!isWhiteLabeled ? (
                                    <div className="col-xs-12 col-sm  flex-grow-null col-no-gutter">
                                        <div className="footer-feedback">
                                            {i18nLang && i18nLang.language === "en" && (
                                                <a
                                                    href={
                                                        authData.isIDFUser ? "https://www.surveymonkey.com/r/IDFmemfeedback" : "https://www.surveymonkey.com/r/YMZQJYJ"
                                                    }
                                                    onClick={() => window.addToDataLayer({ event: "Footer Feedback Link" })}
                                                    id="btn-leave-feedback"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    <em className="las la-comments"></em> We'd love to hear your feedback
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    ""
                                )}
                            </div>
                        </div>
                    </div>
                }
                <div className="footer-bottom">
                    <div className="l-page-container">
                        <div className="row row-width between-sm middle-sm">

                            <div className="col-xs-12 col-sm col-no-gutter">
                                <div>
                                    <div className="footer-links">
                                        <ul className="list-reset list-inline">
                                            {!isPartnerIdIsGoezshield && (
                                                <>
                                                    {trustCenterLegalDocumentLink && trustCenterLegalDocumentLink.length > 0 && !isPartnerIdIsMWB && (
                                                        <li>
                                                            <a
                                                                href={openTrustCenterPage()}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                                onClick={() => {
                                                                    window.addToDataLayer({ event: "FooterTrustCenterLink" });
                                                                }}
                                                            >
                                                                <span className="nav-text">{tLang("PageFooter.label2")}</span>
                                                            </a>
                                                        </li>
                                                    )}
                                                    <li>
                                                        <a
                                                            href={openTermsOfUsePage()}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            onClick={() => {
                                                                window.addToDataLayer({ event: "Terms of Use" });
                                                            }}
                                                        >
                                                            <span className="nav-text">{termsOfUseLegalDocumentLabel}</span>
                                                            {legalDocUpdate.termsAndConditionUpdated && newTag()}
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            href={openPrivacyPolicyPage()}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            onClick={() => {
                                                                window.addToDataLayer({ event: "Privacy Policy" });
                                                            }}
                                                        >
                                                            <span className="nav-text">{isIDFPartner ? "Privacy Notice" : privacyPolicyLegalDocumentLabel}</span>
                                                            {legalDocUpdate.privacyPolicyUpdated && newTag()}
                                                        </a>
                                                    </li>
                                                    {personalInfoWeCollect()}
                                                </>
                                            )}
                                            {isPartnerIdIsGoezshield && (
                                                <>
                                                    <li>
                                                        <a href="https://www.sontiq.com/trust-center/" target="_blank" rel="noreferrer">
                                                            <span className="nav-text">  {tLang("PageFooter.label2")} </span>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            href={openTermsOfUsePage()}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            onClick={() => {
                                                                window.addToDataLayer({ event: "Terms of Use" });
                                                            }}
                                                        >
                                                            <span className="nav-text">{tLang("PageFooter.label3")}</span>
                                                            {legalDocUpdate.termsAndConditionUpdated && newTag()}
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="https://www.sontiq.com/privacy-policy/" target="_blank" rel="noreferrer">
                                                            <span className="nav-text">{tLang("PageFooter.label4")}</span>
                                                            {legalDocUpdate.privacyPolicyUpdated && newTag()}
                                                        </a>
                                                    </li>
                                                    {personalInfoWeCollect()}
                                                </>
                                            )}

                                            {isOneTrustPartner &&
                                                latestUserDashboardStatus == "" &&
                                                !isTUVIP && (
                                                    <li id="cookie-pref-footer-link">
                                                        <a className="ot-sdk-show-settings" style={{ cursor: "pointer" }} >
                                                            <span className="nav-text" >
                                                                Cookie Preferences
                                                            </span>
                                                        </a>
                                                    </li>)}

                                            {/*{!isLife360PartnerId && (partnerProvider === 'EZS' && !isWhiteLabeledEZSPartner) &&  !isHideCommonDefinitions && */}
                                            {/*    <li>*/}
                                            {/*        <a href="#" onClick={openCommonDefinitionPage}>*/}
                                            {/*            <span className="nav-text">Common Definitions</span>*/}
                                            {/*        </a>*/}
                                            {/*    </li>*/}
                                            {/*}*/}
                                            {/*{pathLocation === "ProvisionalResponseLandingPage1" || pathLocation === "ProvisionalResponseLandingPage2" || pathLocation === "StartProtection" || pathLocation === "PssSisk" || pathLocation === "Aflac" || pathLocation === "AflacRegister" ? (*/}
                                            {/*    <li>*/}
                                            {/*        <a*/}
                                            {/*            href="https://www.sontiq.com/privacy-policy/#notice-at-collection"*/}
                                            {/*            target="_blank"*/}
                                            {/*            rel="noreferrer"*/}
                                            {/*            onClick={() => {*/}
                                            {/*                window.addToDataLayer({ event: "Personal Information We Collect" });*/}
                                            {/*            }}*/}
                                            {/*        >*/}
                                            {/*            <span className="nav-text">*/}
                                            {/*                {isIDFPartner ? tLang("PageFooter.label8") : tLang("PageFooter.label8")}*/}
                                            {/*            </span>*/}
                                            {/*        </a>*/}
                                            {/*    </li>*/}
                                            {/*) : null*/}
                                            {/*}*/}
                                            {
                                                !isPartnerIdIsNexshield && !isPartnerIdIsInfodefender && !isPartnerIdADT && !isPartnerIdIsMWB && !isPartnerIdIsEsetGlobal && !isPartnerIdSentryshield && (
                                                    <>

                                                        <li>
                                                            <a
                                                                href={openDoNotSellMyInformationPage()}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                                onClick={() => {
                                                                    window.addToDataLayer({ event: "Your Privacy Choices" });
                                                                }}
                                                            >
                                                                <span className="nav-text">
                                                                    {isIDFPartner ? tLang("PageFooter.label1") : tLang("PageFooter.label1")}
                                                                </span>
                                                                <img src={yourPrivacyChoice} style={{ marginLeft: "5px", marginBottom: "-3px" }} alt='Privacy Choices' />
                                                            </a>
                                                        </li>
                                                    </>
                                                )}
                                        </ul>
                                    </div>
                                    <div className="footer-copyright" >
                                        <span>
                                            &copy; {new Date().getFullYear()} {partnerLegalName.replace(".", "")}. {tLang("PageFooter.label5")}.
                                        </span>{" "}
                                        <span>{tLang("PageFooter.label6")} 6.0.0.92</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            {isLanguagePreferenceDialogOpen && (
                <DialogComponent hideCloseButton={false} dialogId="dialog-language-preference" title="" closeDialog={closeLanguagePreferenceDialog}>
                    <LanguagePreferenceDialog closeDialog={closeLanguagePreferenceDialog} changeLanguage={languageChange} />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default PageFooter;
